/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-one-expression-per-line */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';
import { SimpleInputMask } from 'components/InputMask';

import { StyledDialog, Content } from './styles';

// Modal do Código de confirmaçÃo
const RecoverPhoneModal = ({
  phone, open,
  showModal,
  onClose, updatePhoneNumber,
}) => {
  const [code, setCode] = useState('');
  const [disabled, setDisabled] = useState(true);

  const handleChange = (e) => setCode(e.target.value);

  // Completa alteração após o código de verificação ser inserido
  const handleSubmit = (e) => {
    e.preventDefault();
    updatePhoneNumber(code);
  };

  useEffect(() => {
    if (!open) setDisabled(true);
    if (disabled && open) {
      setTimeout(() => {
        setDisabled(false);
      }, 15000);
    }
  }, [open, disabled]);

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
    >
      <Content>
        <IconButton
          color="secondary"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <Title>Código de verificação</Title>
        <Text>
          Digite o código de 6 dígitos que enviamos para <strong>{phone}</strong>
        </Text>
        {/* FORMULÁRIO */}
        <form onSubmit={handleSubmit}>
          {/* Código de verificação */}
          <SimpleInputMask
            icon
            required
            autoFocus
            name="code"
            value={code}
            onChange={handleChange}
            mask="999999"
            placeholder="Código de verificação"
          />
          <Button type="submit">
            Confirmar
          </Button>
          <Button
            onClick={showModal}
            variant="outlined"
            style={{ border: 0, textDecoration: 'underline' }}
            disabled={disabled}
          >
            Não recebi meu código
          </Button>
        </form>
      </Content>
    </StyledDialog>
  );
};

RecoverPhoneModal.propTypes = {
  phone: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  updatePhoneNumber: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
};

export default RecoverPhoneModal;
